export default {
      id: "frame-16-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#frame-16-usage",
      toString: function () {
        return this.url;
      }
    }